import {Button, ButtonProps} from "@web-libs/ui/ui-components/buttons/button";
import {FieldError} from "@web-libs/core/forms/ui/fields/shared/field-error";
import {CSSProperties} from "react";

export type FormButtonProps = ButtonProps & {
    error?: string
    wrapperStyle?: CSSProperties
}

export const FormButton = (props: FormButtonProps) => {
    return (
        <div style={props.wrapperStyle}>
        {props.error ? <FieldError error={props.error}></FieldError> : <div style={{height:20}}></div>}
        <Button {...props} style={{width:"100%", marginTop:8, ...props.style}} />
        </div>
    )
}
